export default "__VITE_ASSET__r$F2rQtv__"